export type PermissionItem = {
  id: string;
  name: string;
  display_name: string;
  group_name: string;
};

export type PermissionsMap = Record<string, PermissionItem[]>;

export const buildPermissionsMap = (
  permissions: PermissionItem[] | undefined,
): PermissionsMap => {
  if (!permissions) return {};

  return permissions.reduce((acc, permission) => {
    acc[permission.group_name] = [
      ...(acc[permission.group_name] || []),
      permission,
    ];
    return acc;
  }, {} as PermissionsMap);
};

export const filterPermissionsByQuery = (
  permissionsMap: PermissionsMap,
  localSearchQuery: string,
): PermissionsMap => {
  if (!permissionsMap) return {};
  const filteredPermissions = Object.entries(permissionsMap).reduce(
    (acc, [groupName, permissions]) => {
      const filtered = permissions.filter(
        (permission) =>
          permission.display_name
            .toLowerCase()
            .includes(localSearchQuery.toLowerCase()) ||
          permission.name
            .toLowerCase()
            .includes(localSearchQuery.toLowerCase()) ||
          permission.group_name
            .toLowerCase()
            .includes(localSearchQuery.toLowerCase()),
      );
      if (filtered.length > 0) {
        acc[groupName] = filtered;
      }
      return acc;
    },
    {} as PermissionsMap,
  );

  return filteredPermissions;
};

export const computeRoleType = (
  localRolePermissions: { name: string; id: string }[],
): "admin" | "editor" | "reader" | "empty" => {
  let type: "admin" | "editor" | "reader" | "empty" = "empty";
  if (localRolePermissions.length === 0) {
    return type;
  }
  if (
    localRolePermissions.some((permission) => permission.name.includes("read"))
  ) {
    type = "reader";
  }
  if (
    localRolePermissions.some((permission) => {
      return (
        permission.name.includes("update") ||
        permission.name.includes("edit") ||
        permission.name.includes("create")
      );
    })
  ) {
    type = "editor";
  }
  if (
    localRolePermissions.some((permission) => {
      return (
        permission.name.includes("roles:create") ||
        permission.name.includes("roles:update") ||
        permission.name.includes("roles:delete") ||
        permission.name.includes("roles:assign-permissions") ||
        permission.name.includes("users:delete") ||
        permission.name.includes("users:assign-role") ||
        permission.name.includes("users:activate") ||
        permission.name.includes("users:create") ||
        permission.name.includes("users:update") ||
        permission.name.includes("users:reset-password")
      );
    })
  ) {
    type = "admin";
  }
  if (type === "empty") {
    type = "editor"; // Default to editor if no permissions match
  }
  return type;
};
